// ==============================|| PRESET THEME - DEFAULT ||============================== //

export default function Default(colors) {
  const { blue, red, gold, cyan, green, grey } = colors;
  const greyColors = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };
  const contrastText = '#fff';

  return {
    primary: {
      lighter: '#e6f4ff',
      100: '#b3d9ff',
      200: '#80bfff',
      light: '#4da3ff',
      400: '#1a87ff',
      main: '#0066cc',
      dark: '#0052a3',
      700: '#003d7a',
      darker: '#002952',
      900: '#001429',
      contrastText
    },
    secondary: {
      lighter: greyColors[100],
      100: greyColors[100],
      200: greyColors[200],
      light: greyColors[300],
      400: greyColors[400],
      main: greyColors[500],
      600: greyColors[600],
      dark: greyColors[700],
      800: greyColors[800],
      darker: greyColors[900],
      A100: greyColors[0],
      A200: greyColors.A400,
      A300: greyColors.A700,
      contrastText: greyColors[0]
    },
    error: {
      lighter: red[0],
      light: red[2],
      main: red[4],
      dark: red[7],
      darker: red[9],
      contrastText
    },
    warning: {
      lighter: gold[0],
      light: gold[3],
      main: gold[5],
      dark: gold[7],
      darker: gold[9],
      contrastText: greyColors[100]
    },
    info: {
      lighter: '#eff6ff',
      light: '#bfdbfe',
      main: '#3b82f6',
      dark: '#2563eb',
      darker: '#1e40af',
      contrastText
    },
    success: {
      lighter: '#eff6ff',
      light: '#93c5fd',
      main: '#3b82f6',
      dark: '#2563eb',
      darker: '#1e3a8a',
      contrastText
    },
    grey: greyColors
  };
}
